import { useShowResponseStatus } from '@/shared';
import { useUpdateWhitelistMutation } from '../store/whitelist-api';
import { handleWhitelistUpdateError } from '../utils/helpers/whitelist-errors';

import type { TWhitelistUpdateParams } from '../store/types';

export const useUpdateWhitelist = () => {
  const [updateWhitelist, { isLoading, isSuccess, error }] = useUpdateWhitelistMutation();
  const updateError = handleWhitelistUpdateError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Данные успешно обновлены',
    error: updateError,
  });

  const handleWhitelistEdit = async (params: TWhitelistUpdateParams) => {
    await updateWhitelist(params);
  };

  return {
    handleWhitelistEdit,
    updateWhitelist,
    isLoading,
  };
};
